
import Chart21 from "../../../assets/duotone/Chart21.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Chart21Icon({ className, dataTestid = "Chart21Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Chart21 data-testid={dataTestid} className={classes} {...rest} />
  );
}
